import { PriceResFormulaContent } from '@/md/entities/priceRes/formFields/PriceResFormulaContent';

// The `value` prop holds the raw tier formula and `node.data.tierVars` the JSON map of the var
// codes referenced in it to the values used when the tier was evaluated
export const PriceResFormulaCellRenderer = ({ node, value }) => (
  <PriceResFormulaContent formula={value} vars={node.data?.tierVars} />
);
